import { colors } from 'Constants/Colors';

export const tabList = (value, i) => ({
  fontWeight: 'bold',
  color: value === i.toString() ? colors.GREEN : colors.BLACK,
  textTransform: 'none',
});

export const boxStyle = { background: 'white' };

export default { tabList, boxStyle };
